export default "__VITE_ASSET__QTd1emNn__"